// // src/pages/ProShop.jsx
// import React, { useEffect, useState } from "react";
// import api from "../api/axiosInstance";
// // import PriceSlider from "../components/PriceSlider";

// const ProShop = () => {
//   const [priceRange, setPriceRange] = useState([5990, 95000]);
//   const [showNumber, setShowNumber] = useState(false);
//   const [products, setProducts] = useState([]);

//   useEffect(() => {
//     api
//       .get("/proshop/get/all")
//       .then((res) => setProducts(res.data))
//       .catch(() => console.error("Failed to load products"));
//   }, []);

//   // const products = [
//   //   {
//   //     id: 1,
//   //     name: "PGM Pro Golf Master Bag",
//   //     price: 72990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743368/Pgm_Pro_Golf_Master_Bag_jxmcvl.webp",
//   //   },
//   //   {
//   //     id: 2,
//   //     name: "Golf Cap",
//   //     price: 65000,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/Golf_Cap_j0xd3b.jpg",
//   //   },
//   //   {
//   //     id: 3,
//   //     name: "Golf Cap Clip",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/GolfCapClip_bghxp0.jpg",
//   //   },
//   //   {
//   //     id: 4,
//   //     name: "Magnetic Ball Marker",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/Magnetic_Ball_Marker_llncut.jpg",
//   //   },
//   //   {
//   //     id: 5,
//   //     name: "Golf Belt",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743368/Golf_Belt_orenxc.jpg",
//   //   },
//   //   {
//   //     id: 6,
//   //     name: "Golf Ball",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/Golf_Ball_w2hbsd.jpg",
//   //   },
//   //   {
//   //     id: 7,
//   //     name: "Golf Ball",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/Golf_Ball_th0poh.jpg",
//   //   },
//   //   {
//   //     id: 8,
//   //     name: "Rain Cover",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909164/RAIN_COVER_aepaj9.jpg",
//   //   },
//   //   {
//   //     id: 9,
//   //     name: "Iron",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909163/IRON_zccgwj.jpg",
//   //   },
//   //   {
//   //     id: 10,
//   //     name: "Hand Towel",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909164/HAND_TOWEL_lqzrz7.jpg",
//   //   },
//   //   {
//   //     id: 11,
//   //     name: "Small Sock",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909164/SMALL_SOCK_pbkjai.jpg",
//   //   },
//   //   {
//   //     id: 12,
//   //     name: "Arm Sleeves",
//   //     price: 50990,
//   //     image:
//   //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909163/ARM_SLEEVES_v0unft.jpg",
//   //   },
//   // ];

//   const filteredProducts = products.filter(
//     (p) => p.price >= priceRange[0] && p.price <= priceRange[1]
//   );

//   return (
//     // <div className="grid grid-cols-12 gap-6 p-6">

//     //   {/* <h1 className="text-3xl md:text-4xl font-bold text-center mb-12">
//     //     Our Proshop
//     //   </h1> */}
//     //   {/* Left Sidebar */}
//     //   {/* <div className="col-span-3 bg-white shadow-md rounded-lg p-4">
//     //     <PriceSlider
//     //       min={5990}
//     //       max={95000}
//     //       step={1000}
//     //       onChange={(range) => setPriceRange(range)}
//     //     />
//     //   </div> */}

//     //   {/* Right Product Grid */}
//     //   <div className="col-span-9">
//     //     {/* <div className="flex justify-between items-center mb-4">
//     //       <h2 className="text-xl font-bold">GOLF SET</h2>
//     //       <div className="flex items-center gap-4">
//     //         <label className="text-sm">Sort by</label>
//     //         <select className="border rounded-md p-1 text-sm">
//     //           <option>Sorting</option>
//     //           <option>Price: Low to High</option>
//     //           <option>Price: High to Low</option>
//     //         </select>
//     //         <div className="flex gap-2">
//     //           <button className="p-2 border rounded">🔲</button>
//     //           <button className="p-2 border rounded">📃</button>
//     //         </div>
//     //       </div>
//     //     </div> */}

//     //     {/* Product Cards */}
//     //     <div className="grid grid-cols-3 gap-6">
//     //       {filteredProducts.map((product) => (
//     //         <div
//     //           key={product.id}
//     //           className="border rounded-lg p-4 text-center shadow-sm hover:shadow-md transition"
//     //         >
//     //           <img
//     //             src={product.image}
//     //             alt={product.name}
//     //             className="w-full h-48 object-contain mb-3"
//     //           />
//     //           {/* <h3 className="text-sm font-medium">{product.name}</h3> */}
//     //           {/* <p className="text-red-600 font-bold">
//     //             ৳ {product.price.toLocaleString()}
//     //           </p> */}
//     //         </div>
//     //       ))}
//     //     </div>
//     //   </div>
//     // </div>
//     <div className="p-6 relative">
//       {/* Floating Contact Button */}
//       <div className="fixed top-20 right-2 z-50 flex flex-col items-end space-y-2 pt-2">
//         <button
//           onClick={() => setShowNumber(!showNumber)}
//           className="bg-green-600 text-white px-4 py-2 rounded-full shadow-lg hover:bg-green-700 transition"
//         >
//           Contact Us
//         </button>
//         {showNumber && (
//           <div className="bg-white text-green-700 px-4 py-2 rounded-lg shadow-md text-sm font-semibold">
//             📞 +8801769662762
//           </div>
//         )}
//       </div>

//       {/* Page Title */}
//       <h1 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800 uppercase">
//         Pro Shop
//       </h1>

//       {/* Product Grid */}
//       <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
//         {filteredProducts?.map((product) => (
//           <div
//             key={product.id}
//             className="border rounded-lg p-2 text-center shadow-sm hover:shadow-md transition"
//           >
//             <img
//               src={product.imageUrls[0]}
//               alt={product.name}
//               className="w-full h-48 object-contain mb-3"
//             />
//             {/* If you want to show name & price, just uncomment */}
//             <h3 className="text-sm font-medium">{product.name}</h3>
//             {/* <p className="text-red-600 font-bold">
//               ৳ {product.price.toLocaleString()}
//             </p> */}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ProShop;

import React, { useEffect, useRef, useState } from "react";
import {
  ShoppingBag,
  Filter,
  Phone,
  Sparkles,
  Tag,
  Award,
  Star,
  ChevronRight,
  Search,
  Grid,
  List,
} from "lucide-react";
import api from "../api/axiosInstance";

const ProShop = () => {
  const [priceRange, setPriceRange] = useState([0, 100000]);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("featured");
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("grid");

  useEffect(() => {
    api
      .get("/proshop/get/all")
      .then((res) => {
        setProducts(res.data);
        setFilteredProducts(res.data);

        // Calculate price range from actual products
        if (res.data.length > 0) {
          const prices = res.data.map((p) => p.price).filter((p) => p > 0);
          const minPrice = Math.min(...prices);
          const maxPrice = Math.max(...prices);
          setPriceRange([minPrice, maxPrice]);
        }
      })
      .catch((err) => {
        console.error("Failed to load products:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Apply filters and sorting
  useEffect(() => {
    let result = [...products];

    // Apply price filter
    result = result.filter(
      (p) => p.price >= priceRange[0] && p.price <= priceRange[1]
    );

    // Apply search filter
    if (searchQuery) {
      result = result.filter((p) =>
        p.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply sorting
    switch (sortBy) {
      case "price-low":
        result.sort((a, b) => a.price - b.price);
        break;
      case "price-high":
        result.sort((a, b) => b.price - a.price);
        break;
      case "name":
        result.sort((a, b) => a.name.localeCompare(b.name));
        break;
      default:
        // Keep original order for featured
        break;
    }

    setFilteredProducts(result);
  }, [products, priceRange, searchQuery, sortBy]);

  const eventRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (eventRef.current) {
        eventRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  const categories = [
    { name: "All Products", count: products.length },
    {
      name: "Golf Bags",
      count: products.filter((p) => p.name.toLowerCase().includes("bag"))
        .length,
    },
    {
      name: "Accessories",
      count: products.filter(
        (p) =>
          p.name.toLowerCase().includes("cap") ||
          p.name.toLowerCase().includes("belt") ||
          p.name.toLowerCase().includes("marker")
      ).length,
    },
    {
      name: "Clothing",
      count: products.filter(
        (p) =>
          p.name.toLowerCase().includes("sleeve") ||
          p.name.toLowerCase().includes("towel") ||
          p.name.toLowerCase().includes("sock")
      ).length,
    },
    {
      name: "Equipment",
      count: products.filter(
        (p) =>
          p.name.toLowerCase().includes("iron") ||
          p.name.toLowerCase().includes("ball")
      ).length,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-16 md:py-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center shadow-2xl">
                <ShoppingBag className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Premium{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Pro Shop</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-400 to-lime-400 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl text-emerald-100 max-w-3xl mx-auto mb-8">
            Discover exclusive golf equipment and accessories curated for
            champions
          </p>

          <div className="flex items-center justify-center gap-4">
            <div className="flex items-center gap-2 text-emerald-200">
              <Award className="w-5 h-5" />
              <span>Official Merchandise</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <Star className="w-5 h-5" />
              <span>Member Discounts</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-12">
        {/* Search and Filter Bar */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 mb-8 border border-emerald-100">
          <div className="flex flex-col lg:flex-row gap-6 items-center">
            {/* Search */}
            <div className="flex-1 w-full">
              <div className="relative">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-200 hover:border-emerald-300 focus:border-emerald-400 focus:outline-none transition-colors"
                />
              </div>
            </div>

            {/* Sort and View */}
            <div
              ref={eventRef}
              className="flex items-center gap-4 w-full lg:w-auto"
            >
              {/* <div className="relative">
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="appearance-none bg-white border-2 border-gray-200 hover:border-emerald-300 rounded-xl px-4 py-3 pr-10 focus:outline-none focus:border-emerald-400 transition-colors cursor-pointer"
                >
                  <option value="featured">Featured</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                  <option value="name">Name (A-Z)</option>
                </select>
                <ChevronRight className="absolute right-3 top-1/2 transform -translate-y-1/2 rotate-90 text-gray-400 pointer-events-none" />
              </div> */}

              <div className="flex border-2 border-gray-200 rounded-xl overflow-hidden">
                <button
                  onClick={() => setViewMode("grid")}
                  className={`p-3 ${
                    viewMode === "grid"
                      ? "bg-emerald-50 text-emerald-600"
                      : "bg-white text-gray-600"
                  }`}
                >
                  <Grid className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setViewMode("list")}
                  className={`p-3 ${
                    viewMode === "list"
                      ? "bg-emerald-50 text-emerald-600"
                      : "bg-white text-gray-600"
                  }`}
                >
                  <List className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>

          {/* Price Filter */}
          {/* <div className="mt-6 pt-6 border-t border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <Filter className="w-5 h-5 text-emerald-600" />
                <span className="font-semibold text-gray-700">Price Range</span>
              </div>
              <div className="text-emerald-600 font-bold">
                ৳{priceRange[0].toLocaleString()} - ৳
                {priceRange[1].toLocaleString()}
              </div>
            </div>
            <input
              type="range"
              min={0}
              max={100000}
              step={1000}
              value={priceRange[1]}
              onChange={(e) =>
                setPriceRange([priceRange[0], parseInt(e.target.value)])
              }
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-emerald-500"
            />
          </div> */}
        </div>

        {/* Categories */}
        <div className="flex overflow-x-auto gap-3 mb-8 pb-2 scrollbar-hide">
          {categories.map((category) => (
            <button
              key={category.name}
              className="flex-shrink-0 px-6 py-3 rounded-xl bg-white/80 backdrop-blur-sm border border-gray-200 hover:border-emerald-300 hover:bg-emerald-50 transition-all duration-300 group"
            >
              <div className="flex items-center gap-3">
                <span className="font-semibold text-gray-700 group-hover:text-emerald-700">
                  {category.name}
                </span>
                <span className="px-2 py-1 text-xs bg-emerald-100 text-emerald-700 rounded-full font-semibold">
                  {category.count}
                </span>
              </div>
            </button>
          ))}
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="text-center py-20">
            <div className="inline-flex items-center gap-3">
              <div className="w-6 h-6 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
              <span className="text-gray-600">Loading products...</span>
            </div>
          </div>
        ) : filteredProducts.length === 0 ? (
          <div className="text-center py-20">
            <ShoppingBag className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-700 mb-2">
              No products found
            </h3>
            <p className="text-gray-500">
              Try adjusting your filters or search term
            </p>
          </div>
        ) : (
          <div
            className={`grid ${
              viewMode === "grid"
                ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
                : "grid-cols-1"
            } gap-6`}
          >
            {filteredProducts.map((product) => (
              <div
                key={product._id}
                className={`bg-white/90 backdrop-blur-sm rounded-2xl border border-gray-100 overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 group ${
                  viewMode === "list" ? "flex" : ""
                }`}
              >
                {/* Product Image */}
                <div
                  className={`relative ${
                    viewMode === "list" ? "w-48 flex-shrink-0" : "h-64"
                  }`}
                >
                  <img
                    src={product.imageUrls?.[0] || product.image}
                    alt={product.name}
                    className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ${
                      viewMode === "list" ? "rounded-l-2xl" : ""
                    }`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 via-transparent to-transparent"></div>

                  {/* Tag Badge */}
                  {product.price > 50000 && (
                    <div className="absolute top-4 left-4">
                      <div className="px-3 py-1.5 rounded-full bg-gradient-to-r from-amber-500 to-yellow-500 text-white text-xs font-bold shadow-lg">
                        PREMIUM
                      </div>
                    </div>
                  )}
                </div>

                {/* Product Info */}
                <div
                  className={`p-6 flex-1 ${
                    viewMode === "list" ? "flex flex-col justify-center" : ""
                  }`}
                >
                  <div className="mb-3">
                    <div className="flex items-center gap-2 mb-2">
                      <Tag className="w-4 h-4 text-emerald-500" />
                      <span className="text-sm text-emerald-600 font-semibold">
                        Pro Shop Exclusive
                      </span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
                      {product.name}
                    </h3>
                    {viewMode === "grid" && (
                      <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                        Premium golf equipment for the discerning player
                      </p>
                    )}
                  </div>

                  {/* <div className="flex items-center justify-between">
                    <div>
                      <div className="text-2xl font-bold text-emerald-600">
                        ৳{product.price?.toLocaleString() || "N/A"}
                      </div>
                      {viewMode === "list" && (
                        <div className="text-sm text-gray-500 mt-1">
                          Member price available
                        </div>
                      )}
                    </div>
                    <button className="px-6 py-2.5 rounded-xl bg-gradient-to-r from-emerald-500 to-lime-500 text-white font-semibold hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl">
                      View Details
                    </button>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Product Count */}
        <div className="mt-8 text-center text-gray-600">
          Showing {filteredProducts.length} of {products.length} products
        </div>
      </div>

      {/* Floating Contact Button - number always visible, no click needed */}
      <a
        href="tel:01724177716"
        className="fixed bottom-4 right-4 lg:top-1/2 lg:bottom-auto lg:-translate-y-1/2 z-50 flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-lime-500 text-white px-5 py-3 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105"
      >
        <Phone className="w-5 h-5 flex-shrink-0" />
        <span className="font-semibold whitespace-nowrap">
          Contact us - 01724177716
        </span>
      </a>

      {/* Membership CTA */}
      <div className="mt-12 mb-8 max-w-7xl mx-auto px-4 md:px-8">
        <div className="bg-gradient-to-r from-emerald-500 to-lime-500 rounded-2xl p-8 md:p-12 text-center text-white">
          <div className="inline-flex items-center gap-3 mb-4">
            <Sparkles className="w-8 h-8" />
            <Sparkles className="w-8 h-8" />
            <Sparkles className="w-8 h-8" />
          </div>
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Exclusive Member Discounts
          </h3>
          <p className="mb-6 max-w-2xl mx-auto text-emerald-100">
            RGCC members enjoy special pricing on all pro shop items. Join today
            to access premium products at member-only rates.
          </p>
          <button className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-bold bg-white text-emerald-600 hover:bg-emerald-50 hover:scale-105 transition-all duration-300 shadow-lg">
            <span>Become a Member</span>
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProShop;
